export const staticText = {
  site: {
    notice: "訊息中心",
    system: "系統通知",
    internal: "內部公告",
    assign: "作業指派",
    // overview: "作業總覽",
    overview: "%部門%總覽",
    myjob: "我的工作",
    unpub: "未發佈作業",
    pub: "已發佈作業",
    login: "登入",
    logout: "登出",
    bind: "綁定",
  },
  assignText: {
    control: {
      staff: "請選擇指派人員",
    },
    unpub: {
      title: "未發佈作業",
      btn1: "發佈作業",
      btn2: "發佈後前往確認",
      btn3: "發佈後繼續指派",
      btn4: "發佈中",
    },
    pub: {
      title: "已發佈作業",
      btn1: "新增作業",
      btn2: {
        "show": "顯示已刪除作業",
        "hide": "隱藏已刪除作業",
      }
    },
    popup: {
      leave: {
        title: "確定要離開此頁嗎？",
        content:
          "您所編輯的作業尚未存檔，一旦離開，系統可能不會儲存您所做的變更，所有操作都會遺失。",
        btnMain: "離開此頁",
        btnSub: "停留此頁",
      },
      unedit: {
        title: "確定要放棄編輯嗎？",
        content:
          "您所編輯的作業尚未存檔，一旦放棄，系統可能不會儲存您所做的變更，所有操作都會遺失。",
        btnMain: "放棄編輯",
        btnSub: "繼續編輯",
      },
      create: {
        title: "想要新增作業嗎？",
        content: "請先在未發佈作業頁面，完成新增與發佈唷~",
        btnSub: "先不要",
        btnMain: "立即前往",
      },
      clear: {
        title: "你確定要清空嗎？",
        content: "按下確定後，會將尚未儲存的內容全部清空唷~",
        btnMain: "確定",
        btnSub: "取消",
      },
      delete: {
        title: "你確定要刪除嗎？",
        content: {
          one: "按下確定後，會刪除 %人員% 的%作業%唷~",
          many: "按下確定後，會一起刪除 %人員% 的%作業%唷~",
        },
        btnMain: "確定",
        btnSub: "取消",
      },
      edit: {
        title: "你確定要修改嗎？",
        content: {
          time: "作業時間改為 %開始時間%~%結束時間%",
          staffAdd: "指派人員新增 %新增人員%",
          staffDel: "指派人員刪除 %刪除人員%",
          dptTyp: "部門改為 %部門%",
          dpt: "類型改為 %範本類型%",
          tmp: "範本改為 %範本%",
          wok: "作業改為 %作業%",
          storeAdd: "作業項目新增 %新增作業項目%",
          storeDel: "作業項目刪除 %刪除作業項目%",
          temp_task: "任務改為 %任務%",
        },
        btnSub: "取消",
        btnMain: "確定",
      },
      del: {
        title: "發現團單異動",
        content:
          "我們發現「%項目%」已在團單中刪除，系統將自動清除無效的作業項目，請重新確認是否需要增加其他作業項目唷~",
        btnMain: "立即清除",
        alert: "%項目%已清除成功！",
        fail: "%項目%清除失敗，錯誤代碼 %錯誤代碼%",
      },
      delAll: {
        title: "哎呀~發佈時遇到問題",
        content:
          "我們發現以下作業項目已在團單中刪除，系統將自動清除無效的作業項目，請重新確認是否需要增加其他作業項目唷~",
        btnMain: "立即清除",
        alert: "%項目% 已清除成功！",
      },
    },
    alert: {
      pub: {
        success: "%作業日% 已發佈成功！",
        fail: "%作業日% 發佈失敗，錯誤代碼 %錯誤代碼%",
      },
      creating: {
        errorDrag: "注意：請拖曳左右兩側，調整作業時間",
        errorSame: "注意：請選擇相同的作業時間",
      },
      save: {
        success: "該作業已儲存為草稿囉！",
        fail: "哎呀～儲存失敗，請再試一次（錯誤代碼：%錯誤代碼%)",
      },
      delete: {
        success: "%作業% 已刪除",
        fail: "%作業%刪除失敗，錯誤代碼 %錯誤代碼%",
      },
      edit: {
        success: "%作業% 修改成功",
        fail: "%作業%修改失敗，錯誤代碼 %錯誤代碼%",
      },
    },
    status: {
      unselect: {
        title: "尚未選取指派人員",
        subtitle: "請先選取欲指派之人員、時段",
        noData: "目前沒有發佈作業的紀錄唷～",
      },
      unselect_pub: {
        title: "新增臨時工作",
        subtitle: "想自己編輯工作內容~從這裡開始吧！",
        btn1: "清空內容",
        btn2: "立即發佈",
      },
      new: {
        title: "作業指派",
        subtitle: "請填寫指派作業資訊",
        btn1: "清空內容",
        btn2: "儲存草稿",
        btn3: "儲存中",
      },
      new_pub: {
        title: "新增臨時工作",
        subtitle: "想自己編輯工作內容~從這裡開始吧！",
        btn1: "清空內容",
        btn2: "立即發佈",
      },
      edit: {
        title: "編輯作業",
        subtitle: "請填寫指派作業資訊",
        btn1: "刪除",
        btn2: "修改",
        btn3: "處理中",
      },
      edit_pub: {
        subtitle: "請調整作業時間與指派人員",
      },
      edit_temp: {
        title: "編輯臨時工作",
        subtitle: "請調整作業時間、人員或任務內容",
      },
      edit_delete: {
        title: "此作業已刪除",
        subtitle: "%time% 已刪除",
      }
    },
    assignArea: {
      workDate: {
        title: "作業日：",
      },
      workTime: {
        title: "作業時間：",
        placeholder_s: "開始時間",
        placeholder_e: "結束時間",
      },
      staff: {
        title: "指派人員：",
        placeholder: "指派人員",
      },
      dptTyp: {
        title: "部門：",
        placeholder: "部門名稱",
      },
      dpt: {
        title: "類型：",
        placeholder: "類型名稱",
      },
      date: {
        title: "服務期間：",
      },
      tmp: {
        title: "範本：",
        placeholder: "範本名稱",
      },
      work: {
        title: "作業：",
        placeholder: "作業名稱",
      },
      store: {
        title: "作業項目：",
        placeholder: "作業項目",
      },
      task: {
        title: "任務：",
        placeholder: "任務名稱",
      },
      selectAll: "全選",
      addTask: "新增任務＋",
    },
  },
  overview: {
    control: {
      text1: "查看",
      text2: "的",
      placeholder: {
        date: "請選擇日期",
        tmp: "請選擇範本",
      },
    },
    count: {
      title: "目前待完成任務數",
    },
    wok: {
      countdown: {
        last: "剩下",
        over: "超過",
        day: "天",
        hour: "小時",
        minute: "分鐘",
        secs: "幾秒鐘"
      },
      form: {
        title1: "作業項目",
        title2: "完成進度",
        title3: "更新時間",
      },
      button: {
        detail: "查看任務"
      },
      nowork: {
        null: "目前沒有 待完成 的作業唷",
        fnh: "目前沒有 已完成 的作業唷",
        cxl: "目前沒有 已取消 的作業或作業項目唷",
      }
    },
    task: {
      prev: "上一步",
      show: "顯示",
      hide: "隱藏",
      text: "已完成任務",
      form: {
        title1: "任務內容",
        title2: "完成人員",
        title3: "完成時間",
      },
      finish: "完成",
    },
    status: {
      null: "未開始",
      done: "已完成",
      upd: "前更新",
    },
    select: {
      tmp: "您想看哪個範本呢？",
      wok: "您想看哪個作業列表呢？",
    },
    alert: {
      success: "完成 %任務數% 項任務",
      cancel: "取消 %任務數% 項任務",
      fail: "",
    },
    tip: "新手上路",
  },
  mywork: {
    control: {
      title: "作業日：",
      placeholder: "請選擇日期",
      prev: "前一天",
      next: "後一天",
    },
    wok: {
      title: "當日作業列表",
    },
    delWok: {
      title: "已取消作業列表",
    },
    noData: {
      text1: "尚未安排工作唷～",
      text2: "請與主管確認排班狀況",
      text3: "目前您沒有工作被取消唷~",
    },
    tip: "新手上路",
  },
  login: {
    hotel: "商家代號",
    email: "電子郵件",
    password: "登入密碼",
    forgotPwd: "忘記密碼？",
    btn: {
      login: "登入",
      signup: "註冊",
      reset: "重置密碼",
      back: "返回",
      bind: "綁定",
      prev: "回上一頁",
    },
    verify: "驗證碼",
    message: "請輸入%項目%",
    emailValid: "請輸入正確的電子郵件格式(xxx@xxx.com)",
    verifyValid: "請輸入4位驗證碼",
    line: {
      login: "用 LINE 帳號登入",
      signup: "用 LINE 帳號註冊",
      title: "您確定要繼續登入嗎?",
      content:
        "按下確定後，系統將紀錄您登入名稱與時間，以確保個資安全(若非系統授權使用者，請勿登入以免觸法)",
      btnSub: "取消",
      btnMain: "確定",
    },
    login: {
      title: "嗨~歡迎回來！",
      toSignup: {
        text: "第一次使用 Tickup 嗎？",
        btn: "去註冊",
      },
      other: "使用其他方式登入",
    },
    signup: {
      title: "新朋友註冊",
      toLogin: {
        text: "已經有帳號了嗎？",
        btn: "去登入",
      },
      other: "使用其他方式註冊",
    },
    bind: {
      title: "只差一步！請綁定您的 Tickup 帳號",
      subtitle: "為了讓之後 LINE 登入更快速，請輸入帳密資訊，讓我們記得你！",
      popup: {
        title: "您的綁定已完成",
        content: `<p>接下來~點擊下方按鈕，進入 Tickup 管理後台完成作業吧 :)</p><a class="line-login" href="https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${process.env.REACT_APP_CLIENTID}&redirect_uri=${process.env.REACT_APP_URL}callback/login&state=12345abcde&scope=profile%20openid%20email&nonce=09876xyz" style="display:block;margin:40px auto 0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 70" class="line-logo"><defs></defs><path fill="#fff" d="M36.660669 0c20.253854 0 36.671252 13.147146 36.671252 29.36875 0 5.664732-2.00554 10.953752-5.47423 15.438442a7.5485624 7.5485624 0 01-.67998.84931l-.0212.0238a32.014583 32.014583 0 01-3.98727 3.96875c-10.138832 9.37683-26.831394 20.53696-29.035373 18.82775-1.915583-1.4949 3.153833-8.81592-2.693458-10.033-.410104-.0476-.814917-.0979-1.219729-.1561C13.043961 55.848252.00000288 43.833522.00000288 29.376687-.00793512 13.147146 16.409461 0 36.660669 0z" class="cls-2"></path><path d="M15.385523 38.729712h7.395104a1.9182291 1.9182291 0 001.912938-1.91294v-.15875a1.9182291 1.9182291 0 00-1.912938-1.91294h-5.323416V22.632458a1.9182291 1.9182291 0 00-1.912938-1.912937h-.15875a1.920875 1.920875 0 00-1.912937 1.912937v14.184314a1.9182291 1.9182291 0 001.912937 1.91294zm45.828478-8.882066v-.15875a1.9182291 1.9182291 0 00-1.912937-1.912938h-5.323416v-3.037416h5.323416a1.9182291 1.9182291 0 001.912937-1.912938v-.15875a1.920875 1.920875 0 00-1.912937-1.912937H51.90596a1.9182291 1.9182291 0 00-1.912937 1.912937v14.184308a1.9182291 1.9182291 0 001.912937 1.91294h7.395104a1.9182291 1.9182291 0 001.912937-1.91294v-.15875a1.9182291 1.9182291 0 00-1.912937-1.91293h-5.323416v-3.026836h5.323416a1.920875 1.920875 0 001.912937-1.912938zm-14.223999 8.321146a1.9023541 1.9023541 0 00.552979-1.34144V22.632458a1.9155833 1.9155833 0 00-1.912937-1.910291h-.15875a1.9182291 1.9182291 0 00-1.912938 1.910291v8.326438l-6.910916-9.260417a1.9155833 1.9155833 0 00-1.661584-.965729h-.15875a1.9155833 1.9155833 0 00-1.912937 1.910292v14.18431a1.9182291 1.9182291 0 001.912937 1.91294h.15875a1.9182291 1.9182291 0 001.912938-1.91294v-8.466665l6.961187 9.509125c.04498.0662.08996.12965.140229.1905a1.6113125 1.6113125 0 00.746125.55033 1.8944166 1.8944166 0 00.724959.14288h.15875a1.889125 1.889125 0 00.894291-.22225 1.3837708 1.3837708 0 00.465667-.34661zm-18.830396.56092h.161396a1.9155833 1.9155833 0 001.910292-1.91294V22.632458a1.9155833 1.9155833 0 00-1.910292-1.910291h-.161396a1.9182291 1.9182291 0 00-1.912937 1.910291v14.184314a1.9182291 1.9182291 0 001.912937 1.91294z" class="line-text"></path></svg><span class="line-span">使用LINE帳號登入</span></a>`,
      },
      login: "我想使用一般登入",
    },
    fail: "您的密碼錯誤或該帳號不存在，請檢查後重試",
  },
  loading: {
    search: "正在搜尋中....",
    handle: "正在處理中....",
  },
  tabs: ["待完成", "已完成", "已取消", "全部"],
  notice: {
    filterByDate: "依更新日篩選：",
    filterByWord: "依關鍵字篩選：",
    btn: {
      search: "搜尋",
      add: "＋ 新增公告",
    }
  },
  errorText: {
    "403": "您沒有此使用權限",
    "publish_expire": "由於發布作業數過多，請稍後查詢"
  }
};
